export default {
  headerContent: {
    title: 'Groupama Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Nakliyat (Emtea) Sigortası',
    description: {
      title: 'Groupama Sigorta Nakliyat (Emtea) Sigortası Nedir?',
      content: [
        'Groupama sigorta nakliyat sigortası içerdiği geniş teminatlar ile sigortalının emteasını koruma altına almaktadır.',
        'Nakliyat sigortası yükün taşıma esnasında meydana gelebilecek risklerden birinin gerçekleşmesi sonucunda ortaya çıkan mali kayıpları önlemektedir.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Nakliyat Sigortası Türleri Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında düzenlenmekte olan 4 adet poliçe çeşidi bulunmaktadır.',
          subList: [
            'Kati Poliçe',
            'Flotan Poliçe(Geçici)',
            'Abonman Poliçe',
            'Blok Poliçe'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
